import { useEffect } from "react";

import { mergeByKey, normalizeSocketMessage } from "./ChatUtils";

export function useMessagesFromSocket({
  boxRef,
  currentPhone,
  lastSocketMessage,
  newMsgDividerSetRef,
  setMessageItems,
  setNewMsgDividerId,
}) {
  useEffect(() => {
    if (!lastSocketMessage || !currentPhone) return;
    if (!["NEW_MESSAGE", "REACTION_UPDATED"].includes(lastSocketMessage.type)) return;

    const newMsg = normalizeSocketMessage(lastSocketMessage);

    if (String(newMsg.contact_number) !== String(currentPhone)) return;

    console.log("[ChatWindow] Processing real-time message for current contact");
    console.log(
      `[ChatWindow] WebSocket Message: \n${JSON.stringify(
        lastSocketMessage,
        null,
        2
      )}`
    );

    setMessageItems((prev) => {
      const merged = mergeByKey(prev, [newMsg]);

      if (
        lastSocketMessage.type === "NEW_MESSAGE" &&
        newMsg.direction === "inbound" &&
        !newMsgDividerSetRef.current
      ) {
        newMsgDividerSetRef.current = true;
        setNewMsgDividerId(newMsg.sk);
      }

      requestAnimationFrame(() => {
        const b = boxRef.current;
        if (b) b.scrollTop = b.scrollHeight;
      });

      return merged;
    });
  }, [
    boxRef,
    currentPhone,
    lastSocketMessage,
    newMsgDividerSetRef,
    setMessageItems,
    setNewMsgDividerId,
  ]);
}
